export const PERMISSIONS = {
  LOANS: {
    INDEX: 'loans.index',
    VIEW: 'loans.view',
    CREATE: 'loans.create',
    UPDATE: 'loans.update',
    DELETE: 'loans.delete',
    DOCUMENTS_LIST: 'loan-documents.list',
  },
  DOCUMENTS: {
    INDEX: 'document.index',
    CREATE: 'document.create',
    UPDATE: 'document.update',
    DELETE: 'document.delete',
    DELETE_SELECTED: 'document.delete-selected',
    VIEW: 'document.view',
    DOWNLOAD: 'document.download',
    GET_DECODED: 'document.get-decoded',
    DECLINE: 'document.decline',
    SIGN: 'document.sign',
    GET_POLICY: 'document.getPolicy',
  },
  APPLICATIONS: {
    INDEX: 'applications.index',
    UPDATE: 'applications.update',
    DELETE: 'applications.delete',
    VIEW: 'applications.view',
    DOWNLOAD: 'applications.download',
    STORE_OPTION_LIST: 'applications.storeOptionList',
    DOCUMENT_APPROVE: 'applications.document.approve',
    DOCUMENT_REJECT: 'applications.document.reject',
    ATTACH_EMPLOYEE: 'applications.attach.employee',
    CREATE: 'applications.create',
    WRITE_COMMENT: 'applications.document.write.comment',
    LAWYER_CONCLUSION: 'applications.lawyer.conclusion',
    UNDERWRITER_CONCLUSION: 'applications.underwriter.conclusion',
    APPLICATION_REJECT: 'applications.reject',
  },
  PRODUCTS: {
    INDEX: 'products.index',
    LIST: 'products.list',
    VIEW: 'products.view',
    UPDATE: 'products.update',
    CHANGE_STATUS: 'products.change-status',
  },
  PARTNERS: {
    INDEX: 'partners.index',
    STORE: 'partners.store',
    UPDATE: 'partners.update',
    DELETE: 'partners.delete',
    VIEW: 'partners.view',
  },
  USERS: {
    INDEX: 'users.index',
    VIEW: 'users.view',
    STORE: 'users.store',
    UPDATE: 'users.update',
    DELETE: 'users.delete',
    DELETE_SELECTED: 'users.delete-selected',
  },
  REGIONS: {
    INDEX: 'regions.index',
    CREATE: 'regions.create',
    UPDATE: 'regions.update',
    DELETE: 'regions.delete',
  },
  ROLES: {
    INDEX: 'roles.index',
  },
  MONITORING: {
    INDEX: 'farmer-monitoring.index',
    VIEW: 'farmer-monitoring.view',
    CREATE: 'farmer-monitoring.create',
    ATTRIBUTES: 'farmer-monitoring.attributes',
    UPDATE: 'farmer-monitoring.update',
    DELETE: 'farmer-monitoring.delete',
    DOWNLOAD: 'farmer-monitoring.download',
    DOWNLOAD_REGION: 'farmer-monitoring.download.region',
  },
  FARMER_CRITERIA: {
    INDEX: 'farmer-criteria.index',
    VIEW: 'farmer-criteria.show',
    CREATE: 'farmer-criteria.createOrUpdate',
    UPDATE: 'farmer-criteria.createOrUpdate',
    DELETE: 'farmer-criteria.delete',
    DOWNLOAD: 'farmer-criteria.downloadReport',
  },
};
